module.exports = __webpack_public_path__ + "img/menu-minus-on.69fa66bf.svg";